/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const UNDEFINED_MEDIA_ID = -1;
export const TILE_OUT_OF_VIEW_WIDTH = 10; // WIDTH BY WHICH TILE CAN GO OUT OF THE SCREEN AREA
export const MAX_PROGRESS_IN_MOVIE_DETAILS = 95;
